import { render } from "./CSIBlock.vue?vue&type=template&id=d4cedb70&scoped=true&ts=true"
import script from "./CSIBlock.vue?vue&type=script&lang=ts"
export * from "./CSIBlock.vue?vue&type=script&lang=ts"

import "./CSIBlock.vue?vue&type=style&index=0&id=d4cedb70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4cedb70"]])

export default __exports__